export const safeReload = () => {
  if (typeof window === "undefined") return;

  try {
    // Recarga estándar sin agregar parámetros a la URL
    window.location.reload();
  } catch (reloadError) {
    try {
      window.location.href = window.location.href;
    } catch {
      // noop
    }
  }
};
